<template>
  <div class="tw-relative">
    <div class="tw-space-y-4">
      <div class="tw-w-1/4" v-if="seasons.length > 1">
        <filter-select label="Saison"
                       id="season"
                       :options="seasons.map(s => ({label: `Saison ${s}`, value: s}))"
                       no-results="Aucune saison disponible"
                       v-model.number="season"
                       @change="fetchChampionships()"/>
      </div>
      <div class="tw-flex tw-space-x-4">
        <div class="tw-w-1/4" v-if="season && championships.length > 1">
          <filter-select label="Division"
                         id="championship"
                         :options="championships.map(c => ({label: c.label, value: c}))"
                         no-results="Aucune division disponible"
                         v-model="championship"
                         @change="fetchPhases()"/>
        </div>
        <div class="tw-w-1/4" v-if="championship && phases.length !== 1">
          <filter-select label="Phases"
                         id="phase"
                         :options="phases.map(p => ({label: p.label, value: p}))"
                         no-results="Aucune phase disponible"
                         v-model="phase"
                         @change="fetchPools()"/>
        </div>
        <div class="tw-w-1/4" v-if="phase && pools.length !== 1">
          <filter-select label="Poules"
                         id="pool"
                         :options="pools.map(p => ({label: p.label, value: p}))"
                         no-results="Aucune poule disponible"
                         v-model="pool"
                         @change="fetchDays(); fetchRankings();"/>
        </div>
      </div>
      <div class="tw-w-1/4" v-if="pool && days.length > 1">
        <filter-select label="Journée"
                       id="day"
                       :options="days.map(d => ({label: d.label, value: d}))"
                       no-results="Aucune journée disponible"
                       v-model="day"
                       @change="fetchMatches()"/>
      </div>
    </div>

    <matches-table v-if="matches.length" :loading="loading" :matches="matches" :pool="pool"/>

    <template v-if="rankings.length">
      <h2 class="tw-mt-16">Classement au {{ formatDate(now) }}</h2>
      <rankings-table :rankings="rankings"/>
    </template>

    <loader :loading="loading"/>
  </div>
</template>

<script>
import axios from 'axios';
import FilterSelect from './FilterSelect';
import Loader from './Loader';
import MatchesTable from './MatchesTable';
import RankingsTable from './RankingsTable';

export default {
  components: {RankingsTable, MatchesTable, Loader, FilterSelect},
  props: {
    dataSeasons: {
      type: Array,
      default: () => [],
    },
    dataChampionships: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    loading: false,
    now: new Date(),
    seasons: [],
    season: '',
    championships: [],
    championship: '',
    phases: [],
    phase: '',
    pools: [],
    pool: '',
    days: [],
    day: '',
    matches: [],
    rankings: [],
  }),
  methods: {
    async fetchResource(resource, args = []) {
      this.loading = true;
      try {
        const {data} = await axios.get(window.FFFA.adminUrl, {
          params: {
            action: 'fffa_calendar_api_proxy',
            resource,
            args,
          },
        });
        return data;
      } finally {
        this.loading = false;
      }
    },
    async fetchSeasons() {
      this.seasons = (await this.fetchResource('seasons')).filter(season => {
        if (!this.dataSeasons.length) {
          return true;
        }
        return this.dataSeasons.includes(season);
      });
      this.season = this.seasons[0];
      await this.fetchChampionships();
    },
    async fetchChampionships() {
      this.championship = '';
      this.phase = '';
      this.pool = '';
      this.day = '';
      this.matches = [];
      this.rankings = [];
      if (!this.season) {
        return;
      }
      this.championships = (await this.fetchResource('championships', [this.season])).filter(championship => {
        if (!this.dataChampionships.length) {
          return true;
        }
        return this.dataChampionships.includes(championship.id);
      });
      this.championship = this.championships[0];
      await this.fetchPhases();
    },
    async fetchPhases() {
      this.phase = '';
      this.pool = '';
      this.day = '';
      this.matches = [];
      this.rankings = [];
      if (!this.championship) {
        return;
      }
      this.phases = await this.fetchResource('phases', [this.championship.id]);
      this.phase = this.phases[0];
      await this.fetchPools();
    },
    async fetchPools() {
      this.pool = '';
      this.day = '';
      this.matches = [];
      this.rankings = [];
      if (!this.phase) {
        return;
      }
      this.pools = (await this.fetchResource('pools', [this.phase.id]));
      this.pool = this.pools[0];
      await Promise.all([this.fetchDays(), this.fetchRankings()]);
    },
    async fetchDays() {
      this.day = '';
      this.matches = [];
      if (!this.pool) {
        return;
      }
      this.days = (await this.fetchResource('days', [this.pool.id])).map(day => {
        day.date = new Date(day.date);
        return day;
      });
      this.day = this.days[0];
      await this.fetchMatches();
    },
    async fetchMatches() {
      if (!this.day) {
        return;
      }
      this.matches = (await this.fetchResource('matches', [this.day.id])).map(match => {
        match.date = new Date(match.date);
        return match;
      });
    },
    async fetchRankings() {
      if (!this.pool) {
        return;
      }
      this.rankings = await this.fetchResource('rankings', [this.pool.id]);
    },
    /**
     * @param {Date} date
     * @return {string}
     */
    formatDate(date) {
      return date.toLocaleDateString('fr');
    },
  },
  mounted() {
    this.fetchSeasons();
  },
};
</script>
